// ----------------------------------------------------------------------

export default function Popover({ theme }) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          zIndex: 1000000,
          boxShadow: theme.shadows[25].z12
        }
      }
    }
  };
}
